import { render, staticRenderFns } from "./Colorbar.vue?vue&type=template&id=ecb47fbc"
import script from "./Colorbar.vue?vue&type=script&lang=js"
export * from "./Colorbar.vue?vue&type=script&lang=js"
import style0 from "./Colorbar.vue?vue&type=style&index=0&id=ecb47fbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports